import { Component, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { ModalComponent } from '../modal';
import { GalleryComponent } from '../gallery';
@Component({
    selector: 'app-gallery-modal',
    templateUrl: './gallery-modal.component.html',
    styleUrls: ['./gallery-modal.component.scss']
})

export class GalleryModalComponent {
    @ViewChild(ModalComponent) modal: ModalComponent;
    private files = [];
    private imageIndex = 0;
    private modalSrc;
    private numberText = "";
    private caption = "";
    @Input() canDelete = true;
    @Output() deleted = new EventEmitter();
    @ViewChild(GalleryComponent) imageGallery: GalleryComponent;
    constructor() { }
    getClickedImage(data) {
        this.viewImage(data.index);
    }
    private prev(event: any) {
        this.imageIndex--;
        if (this.imageIndex < 0) {
            this.imageIndex = this.files.length - 1;
        }
        this.viewImage(this.imageIndex);
        event.stopPropagation();
    }
    private next(event: any) {
        this.imageIndex++;
        if (this.imageIndex >= this.files.length) {
            this.imageIndex = 0;
        }
        this.viewImage(this.imageIndex);
        event.stopPropagation();
    }
    deleteImage() {
        let image = this.files[this.imageIndex];
        this.files.splice(this.imageIndex, 1);
        this.deleted.emit(image);
    }
    viewImage(index: number) {
        if (this.invalidIndex(index)) return;
        this.imageIndex = index;
        this.modalSrc = this.imageGallery.getImageUrl(this.files[index]);
        this.numberText = (index + 1).toString() + ' / ' + this.files.length;
        this.caption = this.files[index].name;
        this.modal.show();

    }
    setFiles(files) {
        this.files = files;
    }
    getFiles() {
        return this.files;
    }
    addFiles(files) {
        files.forEach(file => {
            this.files.push(file);
        });
    }
    private invalidIndex(index) {
        return index >= this.files.length || index < 0;
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/gallery-modal/gallery-modal.component.ts